module.exports = __webpack_public_path__ + "static/06-62b4a134bec9094fcbf2f84d8361324f.png";